import {AxiosResponse} from "axios";

import {blurHappened} from "./hooks/BlurProtection";
import {
  Authority,
  AVATAI_URL, basicTheme, BWTheme,
  CandidateStatus,
  UserStatus,
  ValidAudioFormats,
  ValidImageFormats
} from "./model/Constants";
import {CandidateSummaryDto, TestDto} from "./model/Dto";

export function getTheme() {
  const theme = sessionStorage.getItem('theme');
  return theme==="bwContrast" ? BWTheme : basicTheme;
};

export function isDemo() {
  return sessionStorage.getItem('isDemo')==='true';
}

export function isInAvataiSite() {
  //return window.location.hostname.includes(AVATAI_URL) || window.location.hostname.includes(LOCAL_URL);
  return window.location.hostname.includes(AVATAI_URL);
}

function openFullscreen(elem: Element) {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  }/* else if (elem.webkitRequestFullscreen) { /* Safari
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE11
    elem.msRequestFullscreen();
  }*/
}
// PrintScreen can only be caught with keyup
function blockPrintScreen(e: KeyboardEvent) {
  if (e.getModifierState("Alt") ||
    e.getModifierState("AltGraph") ||
    e.getModifierState("Control") ||
    e.getModifierState("Meta") ||
    e.getModifierState("OS") ||
    e.getModifierState("Shift") ||
    e.key === 'PrintScreen'
  ) {
    blurHappened();
    e.preventDefault();
    if (e.key === 'PrintScreen')
      navigator.clipboard.writeText('');
    return false;
  }
  /*else if (e.key === 'Notification' ||
    e.key === 'AudioVolumeDown' ||
    e.key === 'AudioVolumeMute' ||
    e.key === 'AudioVolumeUp'
  )
    blurHappenedF();*/
}
export function disableKeyCommands() {
  document.onkeydown = ()=>{return false;};
  document.oncontextmenu = ()=>{return false;};
  document.addEventListener('keyup', blockPrintScreen);
  document.addEventListener('keydown', blockPrintScreen);
  // use keyup for PrintScreen and keydown for (cmd+shift)
}
export function enableKeyCommands() {
  document.onkeydown = ()=>{};
  document.oncontextmenu = ()=>{};
  document.removeEventListener('keyup', blockPrintScreen);
  document.removeEventListener('keydown', blockPrintScreen);
}

export function toIsoString(date: Date) {
  const tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function(num: number) {
      return (num < 10 ? '0' : '') + num;
    };

  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate()) +
    'T' + pad(date.getHours()) +
    ':' + pad(date.getMinutes()) +
    ':' + pad(date.getSeconds()) +
    dif + pad(Math.floor(Math.abs(tzo) / 60)) +
    ':' + pad(Math.abs(tzo) % 60);
}

const DATE_FORMAT = new Intl.DateTimeFormat("es-CR", {
  dateStyle: "short",
  timeStyle: "short",
});

export function formatDate(date: string) {
  return DATE_FORMAT.format(new Date(date));
}

export function extractData<T>(response: AxiosResponse<T>) {
  return response.data;
}

export function validResourceExtension(resource: string){
  const publicSrc = (resource || "").replace(/\s/g, '');
  const extension = publicSrc.split('.').pop() || "";

  return ValidImageFormats.includes(extension) || ValidAudioFormats.includes(extension);
}

export function shuffle<T>(array: T[]): T[] {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex !== 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}


export function saveByteArray (reportName: string, blob: Blob) {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = reportName;
  link.click();
}

export function saveToTxt (fileName: string, data: JSON) {
  const link = document.createElement('a');
  const str = JSON.stringify(data);
  const bytes = new TextEncoder().encode(str);
  const file = new Blob([bytes], {type: "application/json;charset=utf-8"});
  link.href = window.URL.createObjectURL(file);
  link.download = fileName;
  link.click();
}

// format: AAAA-MM-DD HH:mm:ss
export function displayTime(dateTime: string) {
  if (dateTime) {
    const date = new Date(dateTime);
    const langCode = "es-CR";
    const day = date.toLocaleString(langCode, { day: '2-digit' }); // DD
    const month = date.toLocaleString(langCode, { month: '2-digit' }); // MM
    const year = date.toLocaleString(langCode, { year: 'numeric' }); // YYYY
    const hours = date.toLocaleString(langCode, { hour: '2-digit', hour12: false }).padStart(2,'0'); // hh
    const minutes = date.toLocaleString(langCode, { minute: '2-digit', hour12: false }).padStart(2,'0'); // mm
    const seconds = date.toLocaleString(langCode, { second: '2-digit', hour12: false }).padStart(2,'0'); // ss
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } else {
    return "";
  }
}

export function parseDateTime(dateTime: string) {
  return ( (dateTime) ? dateTime.slice(0,19) : "");
}

export function hasAdequacy(test: TestDto) {
  return ( test.conditions !== undefined && test.conditions==="Ad-1" );
}

export function displayCandidateStatus(status: CandidateStatus) {
  switch(status) {
    case CandidateStatus.INVITED: {
      return "Sin iniciar";
    }
    case CandidateStatus.TEST_COMPLETE: {
      return "Completada";
    }
    case CandidateStatus.TEST_IN_PROGRESS: {
      return "En progreso";
    }
    default: {
      return "";
    }
  }
}
export function displayUserRole(role: Authority) {
  switch(role) {
    case Authority.ROLE_ADMIN: {
      return "Administrador";
    }
    case Authority.ROLE_TEACHER: {
      return "Profesor";
    }
    default: {
      return "";
    }
  }
}

export function displayUserStatus(status: UserStatus) {
  switch(status) {
    case UserStatus.AVAILABLE: {
      return "Disponible";
    }
    case UserStatus.RESERVED: {
      return "Reservada";
    }
    case UserStatus.USED: {
      return "Usada";
    }
    default: {
      return "";
    }
  }
}

export function compareDates(main:string, start:string, end:string) {
  return (Date.parse(main) >= Date.parse(start)) &&
    (Date.parse(main) <= Date.parse(end+"T23:59:59"));
}

export function isInvited(includeInvited: boolean, candidate: CandidateSummaryDto) {
  return includeInvited && (
    candidate.candidateL.status===CandidateStatus.INVITED ||
    candidate.candidateR.status===CandidateStatus.INVITED  ||
    candidate.candidateS.status===CandidateStatus.INVITED );
}

export function hasStarted(includeInProgress: boolean, includeCompleted: boolean, candidate: CandidateSummaryDto) {
  return ( includeInProgress && (
      candidate.candidateL.status===CandidateStatus.TEST_IN_PROGRESS ||
      candidate.candidateR.status===CandidateStatus.TEST_IN_PROGRESS ||
      candidate.candidateS.status===CandidateStatus.TEST_IN_PROGRESS ) ) ||
    ( includeCompleted && (
      candidate.candidateL.status===CandidateStatus.TEST_COMPLETE ||
      candidate.candidateR.status===CandidateStatus.TEST_COMPLETE ||
      candidate.candidateS.status===CandidateStatus.TEST_COMPLETE ) );
}

export function includedInFilter(value: string, filter: string) {
  return (filter==="" ||
    (filter == null && value == null) ||
    ( value != null &&
      value.trim().toLowerCase().includes(filter.trim().toLowerCase()) ) );
}

export function getLicenseName(license: CandidateSummaryDto) {
  return license.name !== null && license.name.includes(" | ") ? license.name.split(" | ")[1] : license.name;
}

export function getLicenseId(license: CandidateSummaryDto) {
  return license.name !== null && license.name.includes(" | ") ? license.name.split(" | ")[0] : license.username;
}